export default {
  methods: {
    // this method handles retrieving Contentful models with the '-gif' prefix if the motion product is a 'gif product'
    getMotionProductContent (contentModuleName) {
      if (this.isGifProduct) {
        return this.contentfulText(`${contentModuleName}-gif`)
      } else {
        return this.contentfulText(contentModuleName)
      }
    }
  },
  computed: {
    isGifProduct () {
      return this.product.VideoURL.indexOf('.gif') > -1
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/grad-images/checkout-download/components/MotionProduct/mixin.js